import LR from "./types/LR";
import LS from "./types/LS";
import MG from "./types/MG";
import ML from "./types/ML";
import MP from "./types/MP";
import MT from "./types/MT";
import PN from "./types/PN";
import PT from "./types/PT";

import type BoundsUtil from "../boundsUtil";
import type MathUtil from "../mathUtil";
import type MatrixUtil from "../matrixUtil";

/**
 * Utilities for working with geometries
 * TODO merge with esWebAPI/src/main/webapp/js/esMapping/es/util/GeomUtils.ts ?
 */
export default class GeomUtil {
    private readonly mathUtil;

    readonly types;

    constructor(boundsUtil: BoundsUtil, matrixUtil: MatrixUtil, mathUtil: MathUtil) {
        this.mathUtil = mathUtil;

        const ls = new LS(boundsUtil, this, matrixUtil);

        this.types = {
            LR: new LR(boundsUtil, this, matrixUtil),
            LS: ls,
            MG: new MG(),
            ML: new ML(boundsUtil, this, matrixUtil),
            MP: new MP(boundsUtil, this, matrixUtil),
            MT: new MT(boundsUtil, matrixUtil, ls),
            PN: new PN(boundsUtil, this, matrixUtil),
            PT: new PT(boundsUtil, matrixUtil)
        };
    }

    /**
     * 
     * @param array 
     * @param start 
     * @param end 
     * @param threshold 
     * @param result 
     * 
     * @returns 
     */
    generalizeLines(array: number[], start: number | null, end: number | null, threshold: number, result?: any[]): any[] {
        if (!start) {
            start = 0;
        }

        if ((!end) && (end !== 0)) {
            end = array.length;
        }

        if (!result) {
            result = [];
        }

        if ((end - start) > 4) {
            this._generalizeLines(array, start, end, threshold, result);
            result.push(array[end-2], array[end-1]);
        } else {
            while (start < end) {
                result.push(array[start++]);
            }
        }

        return result;
    }

    private _generalizeLines(array: number[], start: number, end: number, threshold: number, result: number[]) {
        let s = start;
        const sx = array[s++];
        const sy = array[s++];
        let e = end;
        const ey = array[--e];
        const ex = array[--e];
        let mid = -1;
        let maxDist = -Number.MAX_VALUE;
        while (s < e) {
            const px = array[s++];
            const py = array[s++];
            const dist = Math.abs(this.mathUtil.pointLineDistSq(px, py, sx, sy, ex, ey));
            if (dist > maxDist) {
                maxDist = dist;
                mid = s;
            }
        }

        if (maxDist <= threshold) {
            result.push(sx, sy); // all points are within threshold - simply add start
        } else {
            this._generalizeLines(array, start, mid, threshold, result);
            this._generalizeLines(array, mid - 2, end, threshold, result);
        }
    }

    // /**
    //  * 
    //  * @param x 
    //  * @param y 
    //  * @param ax 
    //  * @param ay 
    //  * @param bx 
    //  * @param by 
    //  * 
    //  * @returns 
    //  */
    // pointLineDist(x: number, y: number, ax: number, ay: number, bx: number, by: number): number {
    //     return Math.sqrt(pointLineDistSq(x, y, ax, ay, bx, by));
    // }
    
    // /**
    //  * 
    //  * @param cx 
    //  * @param cy 
    //  * @param numSegments 
    //  * @param radius 
    //  * 
    //  * @returns 
    //  */
    // createCircle(cx: number, cy: number, numSegments: number, radius: number): ["PN", number[]] {
    //     const a = -Math.PI * 2 / numSegments;
    //     const points = [];
    //     for(let i = 0; i <= numSegments; i++){
    //         const angle = a * i;
    //         points.push(cx + (radius * Math.cos(angle)), cy + (radius * Math.sin(angle)));
    //     }
    //     return ["PN", points];
    // }
}
